import script from "./RegisterGroupItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterGroupItem.vue?vue&type=script&setup=true&lang=js"

import "./RegisterGroupItem.vue?vue&type=style&index=0&id=6ab75a17&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab75a17"]])

export default __exports__